export const MIN_PENDING_TIME_MS = 750

export async function resolveWithDelay<T>(promise: Promise<T>, minTimeout = MIN_PENDING_TIME_MS) {
  const startedAt = Date.now()
  const result = await promise
  const elapsed = Date.now() - startedAt

  if (elapsed < minTimeout) {
    await new Promise(resolve => setTimeout(resolve, minTimeout - elapsed))
  }

  return result
}

export function awaitWithTimeout<T>(promise: Promise<T>, timeout: number): Promise<void> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(resolve, timeout)

    promise
      .then(_ => {
        clearTimeout(timer)
        resolve()
      })
      .catch(error => {
        clearTimeout(timer)
        reject(error)
      })
  })
}

export function promiseWithResolvers<T>(): {
  promise: Promise<T>,
  resolve: (value: T) => void,
  reject: (reason?: Error) => void
} {
  let resolver: (value: T) => void
  let rejector: (reason?: Error) => void

  const promise = new Promise<T>((resolve, reject) => {
    resolver = resolve
    rejector = reject
  })

  return { promise, resolve: resolver!, reject: rejector! }
}